module.exports = __webpack_public_path__ + "static/img/default.7b39fe72.gif";